#import "../fragments/email-automation-status.graphql"

query GetEmailAutomationsReadyToSend($limit: Int!, $cursor: String) {
    emailAutomationStatusesReadyToSend(first: $limit, after: $cursor) {
        pageInfo {
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...EmailAutomationStatus
            }
        }
    }
}
